import React from 'react'
import { AltExpertsListingWidget } from 'components/Widgets'

export const AltExpertsListing = () => <AltExpertsListingWidget />
